import api from '../../global/api';
import { UserStaff } from './staff-types';

export const fetchStaff = async () => {
  const response = await api.get<UserStaff[]>('/staff');
  return response.data;
};
